import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { NgIf } from '@angular/common';
import { LoadingIndicatorComponent } from '../../../core/components';
import { userRequest } from '../../../../modules/fwcore/models/user';
import { AuthorizationService } from '../../../../modules/fwcore/services/authorization.service';


@Component({
  selector: 'app-page-login',
  standalone: true,
  imports: [NgIf, LoadingIndicatorComponent],
  templateUrl: './page-login.component.html',
  styleUrl: './page-login.component.scss'
})
export class PageLoginComponent implements OnInit {
  isLoading: boolean = true;

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth, private router: Router, private authService: AuthorizationService) { }

  async ngOnInit() {
    // Initially show loading indicator while checking authentication
    this.isLoading = true;

    try {
      // Add a small delay to ensure loader is visible
      await new Promise(resolve => setTimeout(resolve, 1000));

      // check if the user is already authenticated.
      // if so route them to the home page
      const isAuthenticated = await this.oktaAuth.isAuthenticated();

      var userrequest = new userRequest();

      if (isAuthenticated) {
        var user = this.oktaAuth.getUser().then(userClaim => {
          var user: string | undefined = '';

          if (userClaim) {
            user = userClaim.preferred_username ?? '';
            userrequest.email = userClaim.email;
            userrequest.lname = userClaim.family_name;
            userrequest.fname = userClaim.given_name;

            this.authService.userPermissionUpdate$(userrequest).subscribe(
              (response: any) => {

                this.router.navigate(['home']);
              }
            );

          };
        });
        return;
      }
    } catch (error) {
      console.error('Error checking authentication:', error);
    }

    // If not authenticated, hide loading and show login UI
    this.isLoading = false;
  }

  login() {
    this.oktaAuth.signInWithRedirect();
  }
  protected userPermissionUpdate(req: userRequest): void {

  }
}
